import vocabulary from "./placeholderVocabulary.json";
import { masterItems } from "./placeholderVocabularyParse";

export {
  STATUS,
  STATUS_FILTERS,
  STATUS_LABELS,
  filterPlaceholderVocabulary,
  masterItems,
  parsePlaceholderVocabularyMd,
} from "./placeholderVocabularyParse";

export const PLACEHOLDER_VOCABULARY = vocabulary;
export const MASTER_PLACEHOLDER_COUNT = masterItems(vocabulary).length;

/** Canonical token name without `@`, e.g. `fullname`. */
export const MASTER_PLACEHOLDER_TOKENS = new Set(
  masterItems(vocabulary).map((item) => String(item.placeholder || "").replace(/@/g, "").toLowerCase()),
);

/**
 * Legacy spellings accepted at SmartPhrase insert time.
 * Builder and Placeholder Vocabulary continue to insert the canonical name.
 * `@PatientName@` lowercases to `patientname`.
 */
export const PLACEHOLDER_ALIASES = {
  patientname: "fullname",
  dos: "dateofservice",
};

export function canonicalPlaceholderName(token) {
  const lower = String(token || "")
    .replace(/@/g, "")
    .toLowerCase();
  return PLACEHOLDER_ALIASES[lower] || lower;
}

/** Canonical `@token@` spelling used by designers and SmartPhrases. */
export function placeholderToken(token) {
  return `@${String(token || "").replace(/@/g, "").toLowerCase()}@`;
}

/** Compact picker label from the vocabulary meaning (drop parenthetical detail). */
export function shortPlaceholderLabel(item) {
  const meaning = String(item?.meaning || "").trim();
  const short = meaning.split("(")[0].trim();
  return short || item?.placeholder || "";
}

/**
 * Group master vocabulary items for the Insert Placeholder dropdown.
 * Reserved / not-yet-implemented tokens are excluded.
 */
export function placeholderPickerGroups(items = PLACEHOLDER_VOCABULARY) {
  const groups = [];
  const bySection = new Map();
  for (const item of masterItems(items)) {
    const section = item.section || "Other";
    let group = bySection.get(section);
    if (!group) {
      group = { id: section, label: section, fields: [] };
      bySection.set(section, group);
      groups.push(group);
    }
    const token = String(item.placeholder || "").replace(/@/g, "").toLowerCase();
    if (!token) continue;
    group.fields.push({
      token,
      label: shortPlaceholderLabel(item),
    });
  }
  return groups;
}
